"use strict";
import { useENSAvatar } from "features/ens/api";
import { useUnitagByAddress } from "features/unitags/hooks";
import { getValidAddress } from "utils/addresses";
export function useAvatar(address) {
  const validated = getValidAddress(address);
  const { data: ensAvatar, isLoading: ensLoading } = useENSAvatar(validated);
  const { unitag, loading: unitagLoading } = useUnitagByAddress(validated || void 0);
  const unitagAvatar = unitag?.metadata?.avatar;
  if (unitagAvatar) {
    return { avatar: unitagAvatar, loading: false };
  }
  if (ensAvatar) {
    return { avatar: ensAvatar, loading: false };
  }
  return { avatar: void 0, loading: ensLoading || unitagLoading };
}
